export default "/images/vendor/flag-icons/flags/1x1/nz.svg?29afa191293fa678462c5436719b7a2b";